// extracted by mini-css-extract-plugin
var _1 = "AIButtonContainedDark-moduleaiButtonContainedDark__jzTWy";
export { _1 as "aiButtonContainedDark" }
